import { render, staticRenderFns } from "./PageVms.vue?vue&type=template&id=74db1685&"
import script from "./PageVms.vue?vue&type=script&lang=js&"
export * from "./PageVms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports